// extracted by mini-css-extract-plugin
export default {"AppSocials":"AppSocials_AppSocials__XfWPQ"};